import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const Schema = z.object({
  category: z.enum(["suggestion", "bug", "question", "other"]),
  message: z.string().trim().min(5).max(5000),
  email: z.string().trim().email().max(255).optional().or(z.literal("")),
  page_url: z.string().max(500).optional(),
  locale: z.string().max(8).optional(),
  user_id: z.string().uuid().optional(),
});

export const submitFeedback = createServerFn({ method: "POST" })
  .inputValidator((input) => Schema.parse(input))
  .handler(async ({ data }) => {
    const { error } = await supabaseAdmin.from("feedback").insert({
      category: data.category,
      message: data.message,
      email: data.email && data.email.length > 0 ? data.email : null,
      page_url: data.page_url ?? null,
      locale: data.locale ?? null,
      user_id: data.user_id ?? null,
    });
    if (error) {
      console.error("[feedback] insert failed", error);
      return { ok: false as const, error: "Could not save feedback" };
    }
    return { ok: true as const };
  });